import { createAsyncThunk } from '@reduxjs/toolkit'
import { GeometryController } from 'controllers/Party/Relations/GeometryController'
import { RowDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const rememberAsPurchasingPart = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'bomItem/rememberAsPurchasingPart',
  async (
    { bomItemId, articleId }: { bomItemId: string; articleId: string },
    thunkAPI
  ) => {
    const projectId = thunkAPI.getState().project.activeProject?.id

    const controller = new GeometryController()

    try {
      await controller.RememberOrForgetGeometryAsPurchasingItem(
        projectId,
        bomItemId,
        true,
        articleId
      )

      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: bomItemId,
          isRememberedPurchasingBoMItem: true,
        } as Partial<RowDto>)
      )
      return Promise.resolve()
    } catch (ex) {
      ShowException('project', ex)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      return thunkAPI.rejectWithValue(ex)
    }
  }
)

export const forgetAsPurchasingPart = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'bomItem/rememberAsPurchasingPart',
  async ({ bomItemId }: { bomItemId: string }, thunkAPI) => {
    const projectId = thunkAPI.getState().project.activeProject?.id

    const controller = new GeometryController()

    try {
      await controller.RememberOrForgetGeometryAsPurchasingItem(
        projectId,
        bomItemId,
        false
      )

      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: bomItemId,
          isRememberedPurchasingBoMItem: false,
        } as Partial<RowDto>)
      )

      return Promise.resolve()
    } catch (ex) {
      ShowException('project', ex)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      return thunkAPI.rejectWithValue(ex)
    }
  }
)
